/*eslint no-undef: "off"*/
const enableMediumZoom = () => {
    const zoom = mediumZoom("img:not(.rounded-full)", {
        margin: 24,
        background: "rgba(0, 0, 0, 0.8)",
        scollOffset: 0
    });
    zoom.on("open", (event) => {
        let classList = event.target.classList;
        if (classList.contains("post-header-img")) {
            event.target.classList.remove("post-header-img");
            event.target.classList.add("post-header-img-removed");
        }
    });
    zoom.on("close", (event) => {
        let classList = event.target.classList;
        if (classList.contains("post-header-img-removed")) {
            event.target.classList.remove("post-header-img-removed");
            event.target.classList.add("post-header-img");
        }
    });
};

export { enableMediumZoom };
